import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "../utils/scroll";

export function useGoToQuote() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(() => {
    if (pathname === "/") {
      scrollToId("devis");
    } else {
      navigate("/");
      window.setTimeout(() => scrollToId("devis"), 80);
    }
  }, [navigate, pathname]);
}
